import _ from 'lodash';
import { types } from 'mobx-state-tree';
import resolveComparator from '../query/helpers/ComparatorResolver';
var QueryFilter = types.model({
    property: types.string,
    value: types.string,
    comparator: types.optional(types.number, 0),
    expressionTreeNodeId: types.optional(types.number, 0)
})
    .named('QueryFilter')
    .views(function (self) { return ({
    get levelId() {
        return _.toInteger((self.expressionTreeNodeId % 10000000) / 10000);
    },
    get groupId() {
        return _.toInteger((self.expressionTreeNodeId % 10000) / 10);
    },
    get parentGroupId() {
        return _.toInteger(self.expressionTreeNodeId / 10000000);
    },
    get hasComplexPropertyAccess() {
        return self.property.includes('<');
    },
    get valueDeserialized() {
        return JSON.parse(self.value);
    },
    hasComparator: function (comparator) {
        return self.comparator === resolveComparator(comparator);
    }
}); })
    .actions(function (self) { return ({
    setValue: function (newValue) {
        self.value = JSON.stringify(newValue);
    },
    setComparator: function (newComparator) {
        self.comparator = resolveComparator(newComparator);
    }
}); });
export default QueryFilter;
export function newQueryFilterSnapshot(property, value, comparator, expressionTreeNodeId) {
    var valueSerialized = JSON.stringify(value);
    var resolvedComparator = resolveComparator(comparator);
    return {
        property: property,
        value: valueSerialized,
        comparator: resolvedComparator,
        expressionTreeNodeId: expressionTreeNodeId
    };
}
//# sourceMappingURL=QueryFilter.js.map